import React, { useContext } from 'react';

import {
  Loader, Row, Col, Image, Heading
} from '@thd-olt-component-react/core-ui';

import { ClearCallbackVerificationApiContext } from '../../context/ClearCallbackVerificationApiContext';

import '../../styles/components/ClearCallbackBody.scss';

const resultsBody = (status) => {
  switch (status) {
  case 'APPROVED':
    return (
      <>
        <Image
          asset="check-circle-green.svg"
          height={150}
          width={150}
          title="Green Checkmark"
          alt="Green Checkmark"
        />
        <div>
          <Heading
            className="callback__heading"
            title="Your verification has been successfully sent back to Home Depot."
            centered
          />
        </div>
      </>
    );
  case 'DENIED':
    return (
      <>
        <Image
          asset="circle-error-icon.svg"
          height={150}
          width={150}
          title="Error Icon"
          alt="Error Icon"
        />
        <div>
          <Heading
            className="callback__heading"
            title="CLEAR can't verify your identity at this time."
            centered
          />
          <Heading
            className="callback__sub-heading"
            title="Please contact CLEAR's contact center for more details. 1-855-CLEARME (253-2763)"
            centered
          />
        </div>
      </>
    );
  case 'DECLINED':
    return (
      <>
        <Image
          asset="alert-warning-yellow.svg"
          height={150}
          width={150}
          title="Home Depot Logo"
          alt="Home Depot Logo"
        />
        <div>
          <Heading
            className="callback__heading"
            title="We're unable to offer certain rentals without verification."
            centered
          />
          <Heading
            className="callback__sub-heading"
            // eslint-disable-next-line max-len
            title="You've chosen not to share verification reults with Home Depot. As a result, we are unable to finalize your rental contract."
            centered
          />
        </div>
      </>
    );
  case 'MISMATCH':
    return (
      <>
        <Image
          asset="alert-warning-yellow.svg"
          height={150}
          width={150}
          title="Alert Warning"
          alt="Alert Warning"
        />
        <div>
          <Heading
            className="callback__heading"
            title="ID must match the name on the contract."
            centered
          />
          <Heading
            className="callback__sub-heading"
            // eslint-disable-next-line max-len
            title="Please verify the names match and try again."
            centered
          />
        </div>
      </>
    );
  case 'UNAVAILABLE':
    return (
      <>
        <Image
          asset="circle-error-icon.svg"
          height={150}
          width={150}
          title="Error Icon"
          alt="Error Icon"
        />
        <div>
          <Heading
            className="callback__heading"
            title="Oops, something went wrong."
            centered
          />
          <Heading
            className="callback__sub-heading"
            title="Please rescan the QR code and try again."
            centered
          />
        </div>
      </>
    );
  default:
    return (
      <>
        <Image
          asset="circle-error-icon.svg"
          height={150}
          width={150}
          title="Error Icon"
          alt="Error Icon"
        />
        <div>
          <Heading
            className="callback__heading"
            title="CLEAR can't verify your identity at this time."
            centered
          />
          <Heading
            className="callback__sub-heading"
            title="Please contact CLEAR's contact center for more details. 1-855-CLEARME (253-2763)"
            centered
          />
        </div>
      </>
    );
  }
}

export const ClearCallbackBody = () => {
  const { data, loading, error } = useContext(ClearCallbackVerificationApiContext)

  return (
    <Row>
      <Col>
        <div className="callback__body">
          {loading && (
            <>
              <Heading
                className="callback__heading"
                title="Retrieving Verification from CLEAR"
                centered
              />
              <Loader active={loading} />
            </>
          )}
          {!loading && error && (
            <>
              <Image
                asset="circle-error-icon.svg"
                height={150}
                width={150}
                title="Error Icon"
                alt="Error Icon"
              />
              <div>
                <Heading
                  className="callback__heading"
                  title="Oops, something went wrong."
                  centered
                />
                <Heading
                  className="callback__sub-heading"
                  title="Please rescan the QR code and try again."
                  centered
                />
              </div>
            </>
          )}
          {!loading && !error && resultsBody(data?.status)}
        </div>
      </Col>
    </Row>
  );
};